import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["choice", "form"]
    static classes = ["hidden"]

    connect() {
        this.showChoice()
    }

    showManual(e) {
        if (e) e.preventDefault()
        this.choiceTarget.classList.add("hidden")
        this.formTarget.classList.remove("hidden")

        requestAnimationFrame(() => {
            this.formTarget.classList.remove("opacity-0", "translate-y-4")
        })
    }

    showChoice(e) {
        if (e) e.preventDefault()
        this.formTarget.classList.add("opacity-0", "translate-y-4")

        setTimeout(() => {
            this.formTarget.classList.add("hidden")
            this.choiceTarget.classList.add("opacity-0")
            this.choiceTarget.classList.remove("hidden")
            requestAnimationFrame(() => {
                this.choiceTarget.classList.remove("opacity-0")
            })
        }, 300)
    }
}
